module.exports = __webpack_public_path__ + "img/social.689c50bd.png";